<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vii"></a>For Matt and Eve</p>
<p class="ded1">(Eva Maria, that is, the once and future princess)</p>
<p class="dedt">“Tread softly, because you tread on [their] dreams.”</p>
<p class="dedr">—<em class="italic">W. B. Yeats</em><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Ded.vue?4bae0447